import "@/index.scss";

import { createRoot } from "react-dom/client";
import {
  createHashRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";

import { env } from "@/utils/environmentHelpers";
import { initTranslation } from "@/utils/i18n";
import { initializeSentry } from "@/utils/initializeSentry";
import { initKeyboardModalityTracking } from "@/utils/keyboardModality";

import { CustomerAppProviders } from "./apps/customer/App";
import { customerRoutes } from "./apps/customer/routes";
import { partnerRoutes } from "./apps/partner/routes";

const enableMocking = async () => {
  if (process.env.NODE_ENV !== "development") {
    return;
  }

  if (import.meta.env.MODE === "mocked") {
    const { worker } = await import("@/mocks/msw");

    return worker.start();
  }

  return;
};

// Keep oauth code param handling identical to the original entry
const searchMatch = window.location.search.match(/^\?code=([a-zA-Z0-9]*)$/);
if (searchMatch && searchMatch?.length > 1) {
  window.location.replace(
    window.location.origin +
      window.location.pathname +
      (window.location.hash || "#/welcome/loading") +
      window.location.search,
  );
} else {
  if (env.isProd) {
    initializeSentry();
  }

  initTranslation();
  initKeyboardModalityTracking();

  // Merge customer and partner routes into a single router
  const router = createHashRouter(
    createRoutesFromElements([...customerRoutes, ...partnerRoutes]),
  );
  enableMocking().then(() =>
    createRoot(document.getElementById("root")!).render(
      <CustomerAppProviders>
        <RouterProvider router={router} />
      </CustomerAppProviders>,
    ),
  );
}
